import { useErpConnection } from 'behaviour/jobs';
import { ErpConnectionAlert, TestDataIndexingAlert } from 'components/alerts';
import FormBuilder from 'components/form/builder/FormBuilder';
import FormContext from 'components/form/builder/FormBuilderContext';
import { IndexingSummary, RunIndexingButton } from 'components/testDataIndexing';
import { PrefillContent } from 'components/testDataPrefill';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { schemaGenerator } from './schema';

function ProductsForm({
  jobName, configuration, handleSubmit,
}) {
  const parameters = get(configuration, 'parameters.Parameters.value') || {};
  const schema = useMemo(
    () => schemaGenerator(jobName, parameters),
    [jobName, parameters],
  );
  const indexingRuns = get(configuration, 'job.indexingTask.runs');
  const { isErpConnectionAvailable } = useErpConnection({ jobName });
  const showErpConnectionAlert = isErpConnectionAvailable === false;
  const [expandAllSections, setExpandAllSections] = useState(false);
  const expansionPanelsState = { expandAllSections, setExpandAllSections };

  return (
    <>
      {showErpConnectionAlert && <ErpConnectionAlert />}
      {indexingRuns?.length === 0 && <TestDataIndexingAlert />}
      <FormContext.Provider value={{ parameters, expansionPanelsState }}>
        <FormBuilder
          schema={schema}
          onSubmit={handleSubmit}
          header={<PrefillContent jobName={jobName} schema={schema} />}
          additionalButtons={<RunIndexingButton jobName={jobName} configuration={configuration} />}
          footer={indexingRuns?.length > 0 && <IndexingSummary jobName={jobName} lastRun={indexingRuns[0]} />}
        />
      </FormContext.Provider>
    </>
  );
}

ProductsForm.propTypes = {
  jobName: PropTypes.string.isRequired,
  configuration: PropTypes.shape({
    versionToken: PropTypes.string.isRequired,
  }),
  handleSubmit: PropTypes.func.isRequired,
};

export default ProductsForm;
